<!-- <div class="container-fluid d-flex align-items-center justify-content-center mainContainer">
    <div class="row w-100"> -->
      <!-- Left Section -->
      <!-- <div class="col-md-8 d-none d-md-flex align-items-center justify-content-center">
        <img src="assets/loginLeft.png" alt="" class="col-12 loginbgImg">
        <img src="assets/logo_icon.png" alt="" class="logoImg">
      </div> -->
      
      <!-- Right Section -->
      <!-- <div class="col-md-4 col-12 d-flex align-items-center justify-content-center rightSection">
        <div class="login-form w-60">
          <h2 class="fw-bold text-xl"> Email</h2>
          <p class="text-muted">Enter Your Email</p> -->
          
          <!-- Updated form with proper bindings -->
          <!-- <form [formGroup]="emailForm" class="pt-4">
            <div class="input-group mb-2 fieldContainer">
              <input 
                type="email" 
                class="form-control border-0" 
                placeholder="Enter your email"
                formControlName="email">
            </div>
            
            <div *ngIf="showError" class="text-danger pb-3 text-center">
              {{ errorMessage }}
            </div>
          
            <button 
              type="submit" 
              class="btn btn-primary w-100 py-2"
              (click)="onSendOTPClick()"
              [disabled]="isLoading || !emailForm.valid"
              >
              <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            <span>{{ isLoading ? 'Sending OTP...' : 'Send OTP' }}</span>
            </button>
          </form>
      
          
        </div>
      </div>
    </div> -->
    <!-- <app-notification-popup [isOpen]="showPopup" [message]="popupMessage" [type]="popupType" (onClose)="closePopup()"></app-notification-popup> -->
  <!-- </div> -->



  <div class="maindiv flex items-center justify-center min-h-screen bg-cover bg-center px-4" style="background-image: url('assets/newui/background.png');">
    <div class="bg-white formcontainer shadow-lg p-4 sm:p-8 md:p-12 w-full max-w-md">
        <h2 class="text-xl sm:text-2xl font-semibold text-center mb-2">Forgot Password?</h2>
        <p class="text-center text-gray-600 text-xs sm:text-sm mb-4">Please enter your email to reset password</p>
      
        <form [formGroup]="emailForm" class="pt-4">
          <label class="block text-gray-600 text-sm mb-2" for="email">Email Address:</label>
          <div class="input-group mb-6 sm:mb-8 fieldContainer">
            <input 
              type="email" 
              class="w-full px-3 sm:px-4 py-2 border rounded-lg bg-gray-100 text-gray-500" 
              placeholder="Enter your email"
              formControlName="email">
          </div>
          
          <div *ngIf="showError" class="text-danger pb-3 text-center text-sm">
            {{ errorMessage }}
          </div>
        
          <button 
            type="submit" 
            class="w-full btn btn-primary py-2 rounded-lg"
            (click)="onSendOTPClick()"
            [disabled]="isLoading || !emailForm.valid">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            <span>{{ isLoading ? 'Sending OTP...' : 'Send OTP' }}</span>
          </button>
        </form>
    </div>
</div>